import React from "react"
import { useSavedFiltersSearchCandidateContext } from "./SavedFiltersSearchCandidate"
import MyTooltip from "@common-utils/MyTooltip"
import { Form, Formik } from "formik"
import MyInputField from "@common-utils/fields/MyInputField"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"

// Simple search bar
const SavedFiltersSearchCandidateSimpleSearchBar = () => {
     const globalContext = useSavedFiltersSearchCandidateContext()

     function handleSubmit(values: { simpleSearch?: string }) {
          globalContext.setFilters(prev => ({
               ...prev,
               simpleSearch: values.simpleSearch,
          }))
     }

     function handleReset() {
          globalContext.simpleSearchBarFormikRef.current.resetForm() // Reset local form
          globalContext.filtersFormikRef.current.resetForm() // Reset search bar form
          globalContext.setFilters(() => ({ ...globalContext.INITIAL_FILTERS_STATE })) // Reset payload filters

          globalContext.simpleSearchBarFormikRef.current.setSubmitting(true)
     }

     return (
          <Formik<{ simpleSearch?: string }> initialValues={{}} onSubmit={handleSubmit} innerRef={globalContext.simpleSearchBarFormikRef}>
               {helpers => {
                    return (
                         <Form noValidate autoComplete={"off"}>
                              <div className="input-group">
                                   <MyTooltip title={"Voir les filtres"}>
                                        <button
                                             type={"button"}
                                             className={"btn btn-sm btn-outline btn-outline-secondary "}
                                             onClick={() => globalContext.setAreFiltersVisible(prev => !prev)}
                                        >
                                             <i className={"fas fa-filter fs-4 text-dark"} />
                                        </button>
                                   </MyTooltip>
                                   {/* Button that activates mass selection */}
                                   {globalContext.useSavedFiltersQuery.data && globalContext.useSavedFiltersQuery.data.totalElementsInAllPages > 1 && (
                                        <MyTooltip
                                             title={globalContext.isBulkSelectionEnabled.enabled ? "Quitter le mode sélection multiple" : "Activer le mode sélection multiple"}
                                        >
                                             <button
                                                  type={"button"}
                                                  className={`btn btn-sm ${globalContext.isBulkSelectionEnabled.enabled ? "btn-secondary" : "btn-outline btn-outline-secondary"}`}
                                                  onClick={() =>
                                                       globalContext.setIsBulkSelectionEnabled(prev =>
                                                            prev.enabled
                                                                 ? {
                                                                        enabled: false,
                                                                        checkedElementsInPage: [],
                                                                        areAllElementsInAllPagesChecked: false,
                                                                   }
                                                                 : {
                                                                        ...prev,
                                                                        enabled: true,
                                                                   }
                                                       )
                                                  }
                                             >
                                                  <i
                                                       className={`fas ${
                                                            globalContext.isBulkSelectionEnabled.enabled ? "fa-times text-danger fs-2" : "fa-list-check text-dark fs-4"
                                                       }`}
                                                  />
                                             </button>
                                        </MyTooltip>
                                   )}
                                   <MyInputField
                                        name={"simpleSearch"}
                                        value={helpers.values.simpleSearch}
                                        isInvalid={false}
                                        placeholder={"Rechercher ..."}
                                        onChange={val => {
                                             helpers.setFieldValue("simpleSearch", val).then()
                                             globalContext.filtersFormikRef.current.setFieldValue("simpleSearch", val).then()
                                        }}
                                        classNames={"border"}
                                   />
                                   <button type={"submit"} className={"btn btn-sm btn-outline btn-outline-secondary"} disabled={helpers.isSubmitting}>
                                        {helpers.isSubmitting ? <MySimpleSpinner size={"sm"} classNames={"text-dark"} /> : <i className={"fas fa-search text-dark"} />}
                                   </button>
                                   <MyTooltip title={"Réinitialiser les filtres"}>
                                        <button
                                             type={"button"}
                                             className={"btn btn-sm btn-outline btn-outline-secondary"}
                                             onClick={() => handleReset()}
                                             disabled={helpers.isSubmitting}
                                        >
                                             <i className={"fas fa-sync text-dark"} />
                                        </button>
                                   </MyTooltip>
                              </div>
                         </Form>
                    )
               }}
          </Formik>
     )
}

export default SavedFiltersSearchCandidateSimpleSearchBar
